import { css } from '@emotion/react';

export const rootStyles = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--spacing-6);
  border-radius: var(--radius-lg);
`;

export const variantStyles = {
  default: css`
    background-color: var(--surface-page);
    border: 1px solid var(--border-primary);
    box-shadow: var(--shadow-xs);
  `,
  dashed: css`
    background-color: var(--surface-neutral);
    border: 1px dashed var(--border-primary);
  `,
};

export const sectionStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
  min-width: 0;

  & + & {
    margin-top: var(--spacing-4);
    padding-top: var(--spacing-4);
    border-top: 1px solid var(--border-primary);
  }
`;

export const headerStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-3);
`;

export const eyebrowStyles = css`
  letter-spacing: 0.06em;
`;

export const itemListStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const lineStyles = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-4);
`;

export const lineCopyStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  min-width: 0;
`;

export const amountStyles = css`
  flex-shrink: 0;
  text-align: right;
  white-space: nowrap;
`;

export const flushDividerStyles = css`
  && {
    margin: 0;
  }
`;

export const notesStyles = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-2);
`;

export const footnoteStyles = css`
  a {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: var(--spacing-05);
  }
`;

export const ctaStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
  width: 100%;
  min-width: 0;
`;

export const badgeStyles = css`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--spacing-1) var(--spacing-3);
  border-radius: var(--radius-round);
  background-color: var(--color-neutral-100);
`;

export const badgeLabelStyles = css`
  letter-spacing: 0.06em;
`;

export const actionStyles = css`
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  color: var(--text-primary);
  font: inherit;
  text-align: left;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: var(--spacing-1);
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    color: var(--text-action-hover);
  }

  &:focus-visible {
    outline: var(--spacing-05) solid var(--border-focus);
    outline-offset: var(--spacing-05);
    border-radius: var(--radius-sm);
  }
`;
